import * as React from 'react';
import * as routeUrls from 'app/area/shared/route-urls';
import {
  isPresentationTypeSupported,
  createFavouriteComponent
} from 'app/components/favourite-layout';
import { ErrorBoundaries } from './error-boundarie';
import { LayoutType } from '../types-store';
import styles from '../../../selection-report.scss';
import { FavouriteDataModel } from 'app/components/favourite-layout/favourite/common/favourite-interfaces';
import { DrillDownCallback } from 'app/components/favourite-layout/favourite/common/drill-down-model';
import { FavouriteLayoutComponentProps } from 'app/components/favourite-layout/types';

export interface SelectionReportContainerProps {
  layoutTypes: LayoutType[];
  selectedLayoutType?: number;
  numberOfGroupByFields: number;
  selectionReport: FavouriteDataModel;
  layoutAttributes: { [key: string]: string | boolean };
  presentationType: number;
  drillDown: DrillDownCallback;
  requestCustomWidth?: (id: number, val: any) => void;
  reflowHandle: string;
  intl: any;
  translation: any;
  height?: number;
}

class SelectionReportContainer extends React.Component<SelectionReportContainerProps, {}> {

  private caseview = (caseNumber: number) => routeUrls.toCaseView(caseNumber);

  public render() {
    const {
      selectionReport,
      intl,
      translation,
      layoutTypes,
      numberOfGroupByFields,
      selectedLayoutType,
      presentationType,
      layoutAttributes,
      requestCustomWidth,
      reflowHandle,
      height
    } = this.props;

    if (!selectionReport) {
      return null;
    }
    const layoutType = !!layoutTypes && layoutTypes.find(f => f.type.v === selectedLayoutType);
    if (!!layoutType && numberOfGroupByFields > layoutType.maxSelectionCriteria) {
      return <p>
        {this.props.translation.result_cannnot_be_displayed + ': ' +
          + layoutType.maxSelectionCriteria}
      </p>;
    }

    const favouriteProps: FavouriteLayoutComponentProps = {
      layoutAttributes,
      favouriteDataModel: selectionReport,
      drillDown: this.props.drillDown,
      caseview: this.caseview,
      intl,
      translation,
      requestCustomWidth,
      reflowHandle,
      height,
      numberOfGroupByFields
    };

    if (!isPresentationTypeSupported(presentationType)) {
      return <div>
        {`${translation.favourite_unsupported_presentation_type} ${presentationType}`}
      </div>;
    }
    else {
      return <ErrorBoundaries data={this.props.selectionReport}>
        <div className={styles.tableWrapper}>
          {createFavouriteComponent(presentationType, favouriteProps, undefined)}
        </div>
      </ErrorBoundaries>;
    }
  }
}

export { SelectionReportContainer as SelectionReportChart };
